import React from 'react';
import { Calendar, User, ArrowRight } from 'lucide-react';
import getFullUrl from '../../utils/formatUrl';

const defaultPosts = [
    {
        title: "Future of Technical Education in India",
        date: "March 20, 2026",
        author: "Dr. Prem Agarwal",
        image: "https://images.unsplash.com/photo-1523050353055-f1847ad396ad?auto=format&fit=crop&q=80&w=800",
        excerpt: "Exploring the integration of AI and machine learning into traditional engineering curricula..."
    },
    {
        title: "Why Teacher Training matters for 2026",
        date: "March 15, 2026",
        author: "Director Academic",
        image: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&q=80&w=800",
        excerpt: "The shift toward digital pedagogy and emotional intelligence in schools..."
    },
    {
        title: "Placements 2026: The Global Trend",
        date: "March 10, 2026",
        author: "Placement Cell",
        image: "https://images.unsplash.com/photo-1507679799987-c7177c80ad15?auto=format&fit=crop&q=80&w=800",
        excerpt: "Analyzing the top hiring industries and salary expectations for the upcoming batch..."
    }
];

const BlogSection = ({ posts = [] }) => {
    const displayPosts = posts.length > 0 ? posts : defaultPosts;
    // Duplicate for seamless loop
    const sliderItems = [...displayPosts, ...displayPosts];

    return (
        <section id="blog" className="py-24 bg-white relative overflow-hidden group/blog">
            <div className="max-w-7xl mx-auto px-4 relative z-10 mb-16">
                <div className="flex flex-col md:flex-row justify-between items-end">
                    <div className="max-w-xl">
                        <h3 className="text-[#cc0000] font-black uppercase tracking-[5px] text-[11px] mb-4">News & Insights</h3>
                        <h2 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-slate-900">
                            Institutional <span className="text-[#cc0000]">Pulse</span>
                        </h2>
                    </div>
                    <button className="hidden md:flex items-center text-[10px] font-black uppercase tracking-[3px] text-slate-400 hover:text-[#cc0000] transition-colors pb-2 border-b-2 border-slate-100 hover:border-[#cc0000]">
                        VIEW ALL POSTS <ArrowRight size={14} className="ml-2" />
                    </button>
                </div>
            </div>

            <div className="relative flex overflow-x-hidden group">
                <div className="flex animate-marquee group-hover:pause-marquee py-8">
                    {sliderItems.map((post, idx) => (
                        <article key={idx} className="flex-shrink-0 w-[130px] md:w-[450px] mx-2 md:mx-6 group cursor-pointer">
                            <div className="relative aspect-[16/10] overflow-hidden rounded-sm mb-6 shadow-xl group-hover:shadow-2xl transition-all duration-500">
                                <img 
                                    src={post.image?.startsWith('http') ? post.image : getFullUrl(post.image)} 
                                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" 
                                    alt={post.title} 
                                />
                                <div className="absolute top-1 left-1 md:top-4 md:left-4 bg-[#cc0000] text-white text-[6px] md:text-[8px] font-black uppercase py-0.5 md:py-1 px-1 md:px-3 tracking-widest shadow-lg">
                                    {post.category || 'CAMPUS NEWS'}
                                </div>
                            </div>
                            <div className="space-y-4 px-2">
                                <div className="flex flex-col md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-6 text-[8px] md:text-[10px] font-black uppercase text-slate-400">
                                    <span className="flex items-center">
                                        <Calendar size={8} className="md:w-3 md:h-3 mr-1 md:mr-2 text-[#cc0000]" />
                                        {post.date}
                                    </span>
                                    <span className="hidden md:flex items-center">
                                        <User size={8} className="md:w-3 md:h-3 mr-1 md:mr-2 text-[#cc0000]" />
                                        {post.author}
                                    </span>
                                </div>
                                <h3 className="text-[10px] md:text-xl font-black uppercase tracking-tight text-slate-900 group-hover:text-[#cc0000] transition-colors leading-tight line-clamp-1">
                                    {post.title}
                                </h3>
                                <button className="flex items-center text-[7px] md:text-[11px] font-black uppercase tracking-[2px] md:tracking-[3px] text-[#cc0000] pt-1 md:pt-2 border-b border-transparent group-hover:border-[#cc0000] transition-all">
                                    READ <span className="hidden md:inline">ARTICLE</span> <ArrowRight size={10} className="md:w-[14px] md:h-[14px] ml-1 md:ml-2" />
                                </button>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
            
            {/* CSS Animation */}
            <style>{`
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .animate-marquee {
                    animation: marquee 40s linear infinite;
                }
                .pause-marquee {
                    animation-play-state: paused;
                }
            `}</style>
        </section>
    );
};

export default BlogSection;
